/**
 * Capitalização Automática de Títulos de Produtos
 * 
 * Aplica capitalização (primeira letra de cada palavra maiúscula) 
 * nos títulos de produtos apenas na exibição.
 */

(function() {
  'use strict';

  /**
   * Capitaliza a primeira letra de cada palavra em um texto
   * @param {string} text - Texto a ser capitalizado
   * @returns {string} - Texto capitalizado
   */
  function capitalizeProductTitle(text) {
    if (!text || typeof text !== 'string') {
      return text;
    }
    
    // Divide o texto em palavras (separadas por espaços, hífens, ou outros separadores)
    // Processa cada palavra individualmente para capitalizar apenas a primeira letra
    return text.toLowerCase().replace(/\S+/g, function(word) {
      // Para cada palavra, capitaliza apenas o primeiro caractere (se for uma letra)
      // e mantém o resto da palavra em minúsculas
      if (word.length === 0) return word;
      
      // Encontra o primeiro caractere que é uma letra (incluindo acentuadas)
      const firstLetterMatch = word.match(/[a-záàâãéêíóôõúçñ]/i);
      if (!firstLetterMatch) {
        // Se não houver letras, retorna a palavra como está
        return word;
      }
      
      const firstLetterIndex = firstLetterMatch.index;
      const beforeFirstLetter = word.substring(0, firstLetterIndex);
      const firstLetter = word[firstLetterIndex];
      const afterFirstLetter = word.substring(firstLetterIndex + 1);
      
      // Capitaliza apenas a primeira letra e mantém o resto em minúsculas
      return beforeFirstLetter + firstLetter.toUpperCase() + afterFirstLetter.toLowerCase();
    });
  }

  /**
   * Verifica se um nó de texto deve ser ignorado
   * @param {Node} textNode - Nó de texto a verificar
   * @returns {boolean} - true se deve ser ignorado
   */
  function shouldIgnoreTextNode(textNode) {
    const parent = textNode.parentElement;
    if (!parent) return false;

    // Ignora nós dentro de spans de variantes, elementos ocultos, scripts e styles
    return (
      parent.hasAttribute('data-change-title') || 
      parent.classList.contains('visually-hidden') ||
      parent.tagName === 'SCRIPT' ||
      parent.tagName === 'STYLE'
    );
  }

  /**
   * Capitaliza o texto dentro de um elemento, preservando HTML interno
   * @param {HTMLElement} element - Elemento a ser processado
   */
  function capitalizeElementText(element) {
    if (!element) return;

    // Encontra todos os nós de texto no elemento
    const walker = document.createTreeWalker(
      element,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );

    const textNodes = [];
    let node;
    while (node = walker.nextNode()) {
      // Ignora nós que estão dentro de elementos específicos (como spans de variantes)
      if (!shouldIgnoreTextNode(node)) {
        const text = node.textContent.trim();
        // Adiciona apenas nós com texto não vazio
        if (text && text.length > 0) {
          textNodes.push(node);
        }
      }
    }

    // Capitaliza todos os nós de texto principais encontrados
    textNodes.forEach(textNode => {
      const originalText = textNode.textContent.trim();
      if (originalText && originalText.length > 0) {
        const capitalizedText = capitalizeProductTitle(originalText);
        if (originalText !== capitalizedText) {
          textNode.textContent = capitalizedText;
        }
      }
    });
  }

  /**
   * Processa todos os títulos de produtos na página
   */
  function processProductTitles() {
    // Seletores para encontrar títulos de produtos
    const selectors = [
      '.productView-title',
      '.card-title',
      'h1.productView-title',
      'h3.card__heading .card-title',
      '[data-product-title]'
    ];

    selectors.forEach(selector => {
      try {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => {
          // Evita processar múltiplas vezes
          if (!element.hasAttribute('data-title-capitalized')) {
            capitalizeElementText(element);
            element.setAttribute('data-title-capitalized', 'true');
          }
        });
      } catch (e) {
        console.warn('Erro ao processar títulos:', e);
      }
    });
  }

  /**
   * Inicializa o observador de mudanças no DOM
   */
  function initMutationObserver() {
    // Observa mudanças no DOM para produtos carregados dinamicamente
    const observer = new MutationObserver(function(mutations) {
      let shouldProcess = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          // Verifica se foram adicionados elementos relacionados a produtos
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              if (
                node.classList && (
                  node.classList.contains('product-item') ||
                  node.classList.contains('card') ||
                  node.classList.contains('productView-title') ||
                  node.querySelector('.card-title') ||
                  node.querySelector('.productView-title')
                )
              ) {
                shouldProcess = true;
              }
            }
          });
        }
      });

      if (shouldProcess) {
        // Pequeno delay para garantir que o DOM está completamente renderizado
        setTimeout(processProductTitles, 100);
      }
    });

    // Inicia observação
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  /**
   * Inicialização
   */
  function init() {
    // Processa títulos quando o DOM estiver pronto
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        processProductTitles();
        initMutationObserver();
      });
    } else {
      // DOM já está pronto
      processProductTitles();
      initMutationObserver();
    }

    // Processa títulos após um pequeno delay para garantir renderização completa
    setTimeout(processProductTitles, 500);
  }

  // Inicia a capitalização
  init();
})();

